export interface INFLATION_CALCULATOR_PROPS {
  currentCost: number | undefined;
  rateOfInflation: number | undefined;
  timePeriod: number | undefined;
}

export const INFLATION_CALCULATOR_FORMULA = ({
  currentCost,
  rateOfInflation,
  timePeriod,
}: INFLATION_CALCULATOR_PROPS) => {
  if (
    !currentCost ||
    !rateOfInflation ||
    !timePeriod ||
    Number(currentCost) < 0 ||
    Number(rateOfInflation) < 0 ||
    Number(timePeriod) < 0
  ) {
    return {
      currentCostOutput: 0,
      costIncrease: 0,
      futureCost: 0,
    };
  }

  const futureCost =
    currentCost * Math.pow(1 + rateOfInflation / 100, timePeriod);
  const costIncrease = futureCost - currentCost;
  return {
    currentCostOutput: currentCost,
    costIncrease,
    futureCost,
  };
};
